module.exports = __webpack_public_path__ + "static/img/bg35.cb7b8737.png";